import React, { useState, useEffect } from 'react';
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';

import { useLoggedUser } from '../Hooks/useUserHooks';
import { Icons } from '../../utils/Icons';

const SettingsDropdown = () => {
	const { userProfile } = useLoggedUser();
	const navigate = useNavigate();

	//Dropdown Toggle
	const [isProfileDropdown, setIsProfileDropdown] = useState(false);
	const toggleProfileDropdown = () => {
		setIsProfileDropdown(!isProfileDropdown);
	};
	return (
		<React.Fragment>
			<Dropdown
				isOpen={isProfileDropdown}
				toggle={toggleProfileDropdown}
				className='topbar-head-dropdown ms-1 header-item'
			>
				<DropdownToggle
					type='button'
					tag='button'
					className='btn btn-icon btn-topbar btn-ghost-secondary rounded-circle'
				>
					<i className={`${Icons.settings} fs-22`}></i>
				</DropdownToggle>

				<DropdownMenu className='dropdown-menu-end'>
					<h6 className='dropdown-header'>Administración</h6>

					<DropdownItem onClick={() => navigate('/admin/users')}>
						<i className={`${Icons.userCog} text-muted fs-16 align-middle me-1`}></i>
						<span className='align-middle'>Gestión de Usuarios</span>
					</DropdownItem>

					{userProfile?.is_super_admin && (
						<DropdownItem onClick={() => navigate('/admin/roles')}>
							<i className={`${Icons.idCard} text-muted fs-16 align-middle me-1`}></i>
							<span className='align-middle'>Gestión de Perfiles</span>
						</DropdownItem>
					)}
					<DropdownItem onClick={() => navigate('/admin/modules')}>
						<i className={`${Icons.layoutGrid} text-muted fs-16 align-middle me-1`}></i>
						<span className='align-middle'>Módulos</span>
					</DropdownItem>

					<DropdownItem onClick={() => navigate('/admin/payment')}>
						<i className={`${Icons.payment} text-muted fs-16 align-middle me-1`}></i>
						<span className='align-middle'>Estados de Pago</span>
					</DropdownItem>
					<DropdownItem onClick={() => navigate('/admin/module-usage-facts')}>
						<i className={`${Icons.layoutGrid} text-muted fs-16 align-middle me-1`}></i>
						<span className='align-middle'>Uso de módulos</span>
					</DropdownItem>
					<DropdownItem onClick={() => navigate('/admin/masters')}>
						<i className={`${Icons.database} text-muted fs-16 align-middle me-1`}></i>
						<span className='align-middle'>Maestros</span>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default SettingsDropdown;
